import { render, staticRenderFns } from "./ClassData.vue?vue&type=template&id=099208a0&scoped=true&"
import script from "./ClassData.vue?vue&type=script&lang=js&"
export * from "./ClassData.vue?vue&type=script&lang=js&"
import style0 from "./ClassData.vue?vue&type=style&index=0&id=099208a0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099208a0",
  null
  
)

export default component.exports